import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";


const MessageView = ({ Emp_data }) => {

    const [Data, setData] = useState({
        approved_by: "",
        approver: "",
        message: "",
        date_time: "",
        department: "",
        employee: "",
        employee_id: "",
        id: "",
        incharge: '',
        mobile: "",
        no_of_days: "",
        reason_of_leave: "",
        status: ""
    })

    useEffect(() => {
        setData({
            approved_by: Emp_data.approved_by,
            approver: Emp_data.approver,
            message: Emp_data.message,
            date_time: Emp_data.date_time,
            department: Emp_data.department,
            employee: Emp_data.employee,
            employee_id: Emp_data.employee_id,
            id: Emp_data.id,
            incharge: Emp_data.incharge,
            mobile: Emp_data.mobile,
            no_of_days: Emp_data.no_of_days,
            reason_of_leave: Emp_data.reason_of_leave,
            status: Emp_data.status,
        })
    }, [Emp_data])

    function formatDate(dateStr) {
        const date = new Date(dateStr);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12; // Convert to 12-hour format

        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    }


    return (
        <div
            className="modal custom-modal custom-lg-modal fade p-20"
            id="Message-view"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <div className="form-header modal-header-title text-start d-flex align-items-center mb-0">
                            <h4 className="mb-0">Message Details</h4>
                        </div>
                        <button
                            type="button"
                            className="btn-close ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-field-item">
                                    <div className="profile-picture company-detail-head">
                                        <div className="upload-profile">
                                            <div className="add-profile">
                                                <p>Status</p>
                                            </div>
                                        </div>
                                        <div>
                                            {Data.status === "approved" &&
                                                <span className="badge bg-success d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                            {Data.status === "Denied" &&
                                                <span className="badge bg-danger d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                            {Data.status === "Deleted" &&
                                                <span className="badge bg-warning d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                            {Data.status === "applied" &&
                                                <span className="badge bg-secondary d-inline-flex align-items-center me-2">
                                                    <i className="fe fe-check me-1" />
                                                    {Data.status}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="plane-basic-info">
                                    <h5>Basic Info</h5>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Name</h6>
                                                <p>{Data.employee}</p>
                                            </div>
                                            <div className="basic-info-detail">
                                                <h6>Mobile</h6>
                                                <p>{Data.mobile}</p>
                                            </div>
                                            {/* <div className="basic-info-detail">
                                                <h6>User Type</h6>
                                                <p>{Data.user_type}</p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="plane-basic-info plane-detail">
                                    <h5>Message Info</h5>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Apply Date</h6>
                                                <p>{formatDate(Data.date_time)}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6">
                                            <div className="basic-info-detail">
                                                <h6>Approver</h6>
                                                <p>{Data.approver ? Data.approver : "no"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="plane-basic-info plane-detail">
                                    <div className="basic-info-detail">
                                        <h6>Message</h6>
                                        <p>{Data.message}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

MessageView.propTypes = {
    Emp_data: PropTypes.object.isRequired,
};

export default MessageView;

